<template>
  <div>
    <app-cells>
      <app-input v-model="search" type="search" class="input--300" placeholder="Search payments" aria-label="Search payments" @input="onSearch" />
      <app-filters v-model="direction" :filters="directions" name="funding-direction" @change="onFilter" />
      <app-filters v-model="status" :filters="statuses" name="funding-status" @change="onFilter" />
    </app-cells>
    <app-cells v-if="relationshipsFailed">
      <span>Unable to load funding directions</span>
      <app-button @click.native="fetchRelationships">Retry</app-button>
    </app-cells>
    <app-spinner v-if="loading && !loaded" />
    <app-cells v-else-if="failed">
      <span>Unable to load payments</span>
      <app-button @click.native="fetchItems">Retry</app-button>
    </app-cells>
    <template v-else>
      <v-client-table
        :data="items"
        :columns="columns"
        :options="options"
        class="table-default"
        :class="{ 'table-default--loading': loading }"
        :aria-busy="loading"
      >
        <template #h__number><div class="table-default__left">Payment</div></template>
        <template #number="{ row }">
          <div class="table-default__left">
            <router-link :to="{ name: 'transfer-pricing-funding-detail', params: { id: row.id } }" class="table-default__link-border">
              {{ row.number || `Payment ${row.id}` }}
            </router-link>
          </div>
        </template>
        <template #recipient="{ row }">{{ recipientName(row.recipient) }}</template>
        <template #relationship="{ row }">{{ row.relationship ? relationshipName(row.relationship) : (isAltezzaBatch(row) ? 'Historical — not assigned' : '-') }}</template>
        <template #status="{ row }"><funding-status :status="row.status" /></template>
        <template #funding_amount="{ row }">{{ formatAmount(row.funding_amount, row.currency) }}</template>
      </v-client-table>
      <funding-pagination :page="page" :count="count" :length="items.length" @change="changePage" />
    </template>
  </div>
</template>

<script>
import { getTransferPricingFundingBatches } from '@/http'
import FundingPagination from './Pagination'
import FundingStatus from './Status'
import { formatAmount, directionParams, isAltezzaBatch, relationshipName, recipientName, STATUSES, tableOptions } from './funding'
import paginatedList from './paginatedList'
import relationships from './relationships'

export default {
  name: 'TransferPricingFundingList',
  components: { FundingPagination, FundingStatus },
  mixins: [paginatedList, relationships],
  data() {
    const headings = {
      number: 'Payment',
      recipient: 'Recipient',
      relationship: 'Funding direction',
      status: 'Status',
      funding_amount: 'Funding amount',
      groups_count: 'Tours',
    }
    return {
      columns: Object.keys(headings),
      options: tableOptions(headings),
      statuses: [
        { value: '', label: 'All' },
        ...STATUSES.map(item => ({ value: item.code, label: item.name })),
      ],
      direction: '',
      status: '',
    }
  },
  computed: {
    directions() {
      return [
        { value: '', label: 'All' },
        ...this.relationships.map(item => ({ value: item.slug, label: item.name })),
      ]
    },
  },
  methods: {
    formatAmount,
    recipientName,
    relationshipName,
    isAltezzaBatch,
    requestItems(params) {
      const direction = this.direction ? directionParams(this.direction) : {}
      return getTransferPricingFundingBatches({ ...params, ...direction, status: this.status || undefined })
    },
    onFilter() {
      this.changePage(1)
    },
  },
}
</script>
